<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'xl'" :centered="true" :btn_cancel="true"
      :btn_ok="true" :booTitile="true">
      <div class="container">
        <CRow>
          <CCol>
            <div class="table-responsive">
              <table id="dataTableLists"
                class="table table-sm table-hover table-striped table-bordered dt-responsive nowrap" style="width: 100%">
                <thead>
                  <tr>
                    <th width="60">#</th>
                    <th>Sede</th>
                    <th>Fecha</th>
                    <th>Serie y Number</th>
                    <th>Cliente</th>
                    <th>Documento</th>
                    <th>Subtotal</th>
                  </tr>
                </thead>
                <tbody v-if="type === 'BOLETA'">
                  <tr v-for="(doc, index) in item" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ doc.campu.name }}</td>
                    <td>{{ formatDate(doc.date) }}</td>
                    <td>{{ doc.serie }} {{ doc.number }}</td>
                    <td>{{ doc.voucher_fullname}} </td>
                    <td>{{ doc.voucher_document}} </td>
                    <td>{{ doc.amount}} </td>

                  </tr>
                  <tr>
                    <td colspan="6" class="text-end"><strong>Total:</strong></td>
                    <td><strong>{{ totalSum }}</strong></td>
                  </tr>
                </tbody>
                <tbody v-if="type === 'FACTURA'">
                  <tr v-for="(doc, index) in item" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ doc.campu.name }}</td>
                    <td>{{ formatDate(doc.date) }}</td>
                    <td>{{ doc.serie }} {{ doc.number }}</td>
                    <td>{{ doc.voucher_fullname}} </td>
                    <td>{{ doc.voucher_document}} </td>
                    <td>{{ doc.amount}} </td>
                  </tr>
                   <tr>
                    <td colspan="6" class="text-end"><strong>Total:</strong></td>
                    <td><strong>{{ totalSum }}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
          <i class="fa fa-times"></i>&nbsp;Cerrar
        </CButton>
      </template>
    </CModal>
  
  </template>
  <script>
  import CModal from "../../shared/modals/cModalFormCom.vue";
  import { mapActions } from "vuex";
  import moment from "moment";
  
  export default {
    name: "c-reporttypedocument-modal",
    components: {
      CModal,
    },
    data() {
      return {
        swal: null,
      };
    },
    props: {
      title: String,
      boo_modal: Boolean,
      item: {
        type: Array,
        default: []
      },
      type: String,
    },
    computed: {
      totalSum() {
        return this.item.reduce((sum, doc) => sum + (parseFloat(doc.amount) || 0), 0).toFixed(2);
      }
    },
    methods: {
      ...mapActions(["get", "post"]),
      mtdClose() {
        this.$emit("closeModalReportTypeDocument");
      },
      formatDate(date) {
        return moment(date).format("DD/MM/YYYY");
      }
    },
  }
  </script>